import React from 'react'
import { IconFile } from '@tabler/icons-react'
import Typography from '../../atoms/Typography'
import { splitFileName } from '../../../enviroment/lib/fileUtils'
import TooltipWrapper from '../../atoms/TooltipWrapper'
import { ExtBadge } from '../../atoms/ExtBadge'

export function CardHeader({ name, trailing }: { name: string; trailing?: React.ReactNode }) {
  const { base, ext } = splitFileName(name)
  return (
    <div className="mb-2 flex items-center gap-2">
      <IconFile className="h-4 w-4 shrink-0 text-light-green-500" />
      <TooltipWrapper content={name} side="bottom" delayDuration={500}>
        <div className="min-w-0">
          <Typography variant="sm" className="truncate text-gray-50">
            {base}
          </Typography>
        </div>
      </TooltipWrapper>
      {ext && <ExtBadge ext={ext} />}
      {trailing && <div className="ml-auto shrink-0">{trailing}</div>}
    </div>
  )
}
